export default "__VITE_ASSET__b40cde31__"